import { z } from 'zod';

/** The five numbers a CSS `box-shadow` needs, as legacy stored them. */
export const shadowSettingsV0Schema = z.object({
    offsetX: z.coerce.number().default(0),
    offsetY: z.coerce.number().default(0),
    blur: z.coerce.number().default(0),
    spread: z.coerce.number().default(0),
    color: z.string().default(''),
});

export const shadowV0Schema = z.object({
    version: z.literal(0),
    /** `isShadow` — with the shadow off the settings are not read at all. */
    isEnabled: z.boolean(),
    settings: shadowSettingsV0Schema.nullable(),
});
